// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2Of5u","list":"PatternAutocomplete_list__m2hk_"};